import { useMutation, useQueryClient } from '@tanstack/react-query'

import { setQueryKeys } from './set-query-keys'

import { createSet } from '@/services/set/create-set.service'

export function useCreateSet() {
  const queryClient = useQueryClient()

  const mutationCreateSet = useMutation({
    mutationFn: createSet,
    onSuccess: id => {
      queryClient.invalidateQueries({
        queryKey: setQueryKeys.one(id),
      })
    },
  })

  return {
    mutationCreateSet,
  }
}
